module.exports = __webpack_public_path__ + "img/posters.3c2f9e68.png";